var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_check_disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.959,
    height: 60.417,
    viewBox: "0 0 61.959 60.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1029",
    "data-name": "Tracciato 1029",
    d: "M17.332,0,.6,15.245,0,37.689,8.445,55.463l21.473,4.955,20.891-9.3,11.15-20.884L52.808,4.672,28.111.139Z",
    transform: "translate(0 0)",
    fill: "#b2c4bf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1114",
    "data-name": "Tracciato 1114",
    d: "M28.713.238l-14.463,24.5L6.634,11.916l-4.4,4.3L14.251,30.438,34.905,7.7Z",
    transform: "translate(10.854 15.982) rotate(-3)",
    fill: "#fff",
    opacity: 0.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDisabled);
export default __webpack_public_path__ + "static/media/Icon_check_disabled.c62d7d0864864a8fcaf687a37bcf10e1.svg";
export { ForwardRef as ReactComponent };